// extracted by mini-css-extract-plugin
module.exports = {"root":"ImagedPageSection_root__3vc8P","holder":"ImagedPageSection_holder__1hkJA","image":"ImagedPageSection_image__39i4t"};